import React from "react";
import {observer} from "mobx-react";
import {RelatedEntitiesWidgetAsync} from "../../../../../widgets/related-entities-widget/components/related-entities-widget.async";
import {IntersectionObserver} from "../../../../../core/components/intersection-observer/intersection-observer";

export const SideBarModuleRelatedEntities = observer(({controller}) => {
  const {state} = controller;
  const {shouldRenderRelatedEntities, relatedEntitiesProps} = state;

  return shouldRenderRelatedEntities ? <IntersectionObserver><RelatedEntitiesWidgetAsync {...relatedEntitiesProps}/></IntersectionObserver>: null
});